import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import React from "react";

export default function NotFound() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      component={motion.div}
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      sx={{
        minHeight: "100vh",
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center",
        px: "1.5rem",
      }}
    >
      {/* Glass Container */}
      <Box
        component={motion.div}
        initial={{ opacity: 0, scale: 0.92 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        sx={{
          backdropFilter: "blur(16px)",
          borderRadius: "1.5rem",
          border: `1px solid ${theme.palette.primary.main}`,
          padding: "3rem 2rem",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <Typography
          component={motion.h1}
          initial={{ scale: 0.7 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.6 }}
          sx={{
            fontSize: "6rem",
            fontWeight: 900,
            color: theme.palette.primary.main,
          }}
        >
          404
        </Typography>

        <Typography
          sx={{
            fontSize: "1.4rem",
            mt: 2,
            fontWeight: 600,
            // color: theme.palette.secondary.main,
          }}
        >
          صفحه مورد نظر پیدا نشد
        </Typography>

        <Typography
          sx={{
            fontSize: ".95rem",
            mt: 1,
            // color: theme.palette.text.secondary,
            maxWidth: "400px",
            mx: "auto",
          }}
        >
          ممکنه آدرس اشتباه وارد شده باشه یا صفحه حذف شده باشه.
        </Typography>

        <Stack direction="row" gap={2} justifyContent="center" mt={4}>
          <Button
            variant="contained"
            size="large"
            sx={{
              px: 4,
              borderRadius: "12px",
            }}
            onClick={() => navigate("/")}
          >
            بازگشت به صفحه اصلی
          </Button>

          <Button
            variant="outlined"
            size="large"
            sx={{
              px: 4,
              borderRadius: "12px",
            }}
            onClick={() => navigate(-1)}
          >
            بازگشت
          </Button>
        </Stack>
      </Box>
    </Stack>
  );
}
